const make_uppercase = (words_array = false) => {

    if(!words_array) {
        words_array = [
            'Blanche',
            'Vivo',
            'Circle',
            'Alba',
            'Riccarda',
            'Doppio',
            'Puff twice',
            'Puff one',
            'Ria',
            'Karrera',
            'Moko',
            'Woody t',
            'Riviera t',
            'Soho t',
            'Palio T',
            'Carre',
            'Corto',
            'Lungo',
            'Quadro',
            'Sphera',
            'Corso',
            'Tati',
            'Dionigi',
            'Too night',
            'Eterna',
            'Limura',
            'Vogue',
            'Laval',
            'Nino',
            'Sani',
            'Nubi',
            'Ilaria',
            'Habana',
            'Melia',
            'La isla',
            'Milton',
            'Parma',
            'Sky',
            'Ipsoni',
            'Soho',
            'Moon',
            'Appiani',
            'Ermes',
            'Esse',
            'Tutto',
            'Cliff',
            'Alfinosa',
            'Linda',
            'Orsi',
            'Katarina',
            'Aura',
        ];
    }

    let input, search, pr, result_arr;

    words_array.forEach(function (item) {

        let nodes = findNodes(item);
        FindOnPage(item, nodes);

    });

    function FindOnPage(search_val, nodes) {

        nodes.forEach(function (node) {
            input = search_val;

            search = '/'+input+'/g';
            pr = node.innerHTML;

            result_arr = [];

            pr = pr.replace(eval(search), '<span class="indent" style="text-transform:uppercase;">'+input+'</span>');
 
            node.innerHTML = pr;
        })
    }

    function findNodes(search_val) {
        let word = search_val.toLowerCase(),
            queue = [document.body],
            curr,
            found_nodes = []
        ;
        while (curr = queue.pop()) {

            if (!curr.textContent.toLowerCase().match(word)) continue;
            for (let i = 0; i < curr.childNodes.length; ++i) {
                switch (curr.childNodes[i].nodeType) {
                    case Node.TEXT_NODE : // 3
                        if (curr.childNodes[i].textContent.toLowerCase().match(word)) {
                            found_nodes.push(curr)
                        }
                        break;
                    case Node.ELEMENT_NODE : // 1
                        queue.push(curr.childNodes[i]);
                        break;
                }
            }
        }

        return found_nodes;
    }

};


export default make_uppercase;
